
import { Resolve, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';
import {first, map} from 'rxjs/operators';
import { Observable } from 'rxjs';
import * as moment from 'moment'
    
import { BreaktimeCebuService } from './breaktime-cebu.service';
import { DataService } from '../../user-detail.service';
import { Staff } from '../../models/staff';

@Injectable()
export class BreaktimeCebuResolver implements Resolve<any> {
    constructor(
        private breaktimeService: BreaktimeCebuService,
        private dataService: DataService
    ) {}

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
        let staff: Staff = this.dataService.getStaffInformation;
        let date = moment().format("YYYY-MM-DD");

        return this.breaktimeService.getStaffBreakTime(staff._id, date).pipe(map(resp => {
            return resp;
        }),first(),);
    }
}

